
import styles from '../style.module.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";
import ClockIcon from 'assets/SVG/ClockIcon';
import PhoneSvg from "assets/SVG/PhoneSvg";
import "swiper/css";

function BranchesSlider(props) {

    const { addresses, selectedIndex, handleMarkerClick, handleAddressClick } = props;
    const { currentLanguage } = useSelector(({ main }) => main);
    if (!addresses || addresses.length === 0) return null;

    return (
        <div className={styles.branches_slider}>
            <Swiper
                spaceBetween={12}
                slidesPerView="auto"
                speed={300}
                allowTouchMove={true}
            >
                {addresses.map((address, index) => {
                    const isActive = selectedIndex === index;

                    return (
                        <SwiperSlide
                            key={address.id.toString()}
                            className={styles.branch_slide}
                            onClick={() => {
                                handleAddressClick(
                                    address.location.lat,
                                    address.location.lng,
                                    index
                                );
                                handleMarkerClick(address);
                            }}
                        >
                            <div
                                className={`${styles.branch_card} ${isActive ? styles.branch_card_active : ""}`}
                            >
                                <div className={styles.branch_image_wrap}>
                                    <img
                                        src={process.env.REACT_APP_STORAGE_URL + address['image_' + currentLanguage]}
                                        alt={address.name || "branch"}
                                        className={styles.branch_image}
                                    />
                                    <div className={styles.address_working_times}>
                                        <ClockIcon/>
                                        <span>{ address['work_time_' + currentLanguage] }</span>
                                        <div className={styles.branch_meta_divider} />
                                        <PhoneSvg
                                            width={12}
                                            height={12}
                                        />
                                        <span>
                                            { address['tel_' + currentLanguage] }
                                        </span>
                                    </div>
                                </div>
                                <span className={styles.branch_address}>
                                    { address['address_' + currentLanguage] }
                                </span>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}

export default BranchesSlider;
